import React from 'react';
import AppRoutes from './Routes';
import Loader from "react-js-loader";
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import CookieConsent from "react-cookie-consent";

const App = () => {
  const { loader } = useSelector((state: RootState) => ({
    loader: state.applicationReducer.loader
  }))
  return (
    <div className="App">
      <AppRoutes />
      {loader ? <>
        <div style={{ position: 'absolute', top: '50%', left: 0, right: 0, zIndex: 1000002 }}><Loader type="spinner-cub" bgColor={'#ffff'} color={'#4fa94d'} size={100} />
        </div>
        <div className='backdrop'></div></>
        : null}
      {/* <CookieConsent
        enableDeclineButton={true}
        location="bottom"
        buttonText="Accept"
        cookieName="We "
        style={{ background: ' #0c8548' }}
        buttonStyle={{ backgroundColor: "#c1995b", color: '#fff', }}
        expires={150}
        declineButtonText="Reject"
        containerClasses="cookie-consent-container"
        buttonClasses="cookie-accept-button"
        declineButtonClasses="cookie-decline-button"
        contentClasses="cookie-content"
      >
        <div className='cookie-content-1'>We use cookies on this site to enhance your user experience</div>
        <div className='cookie-content-2'>By clicking "Accept All" you are giving your consent for us to set cookies. By clicking "Reject" you are giving your consent for us to set necessary cookies which track website performance without collection of personal information. <a href="" target="_blank">Privacy Policy</a> </div>
      </CookieConsent> */}
    </div>
  );
}

export default App;
